import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useState } from "react";

const SelectFiltation = (props) => {

  const [currVal, setCurrVal] = useState(props?.value || props.values[0].value);
  const handleSelectValChange = (event) => {
    setCurrVal(event.target.value);
    props.filterBy(event.target.value);
  };

  return (
    <FormControl sx={{ maxWidth: 300, textAlign: "center" }}>
      <Select
        MenuProps={{
          // disableScrollLock: true,
          slotProps: {
            paper: {
              sx: {
                borderRadius: '10px !important',
                boxShadow: '5px 2px 10px 0px rgba(0, 0, 0, 0.08)',
                width: '250px'
              }    
            }
          }
        }}
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            border: 0,
            boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
          },
          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            border: 0,
          },
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
            },

          }}
        style={selectStyles}
        value={currVal}
        onChange={(e) => handleSelectValChange(e)}
      >
        {props.values.map((val, index) => (
          <MenuItem 
          sx={
            {color: 'rgba(0, 0, 0, 0.40)', fontWeight: '400', fontFamily: 'Manrope', fontSize: '18px',
              '&.Mui-selected': {
                backgroundColor: '#D9D9D9 !important'
            }
            }} 
            key={index} value={val.value}
          >
            {val.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectFiltation;

const selectStyles = {
  borderRadius: "100px",
  borderColor: "transparent",
  fontFamily: "Manrope",
  fontSize: '18px',
  color: 'rgba(0, 0, 0, 0.40)',
  padding: '0 40px',
  fontWeight: '400'
};
